export default __webpack_public_path__ + "static/media/how-to-deposit-payment-gateway-video.725e2d5e.mp4";